export const vi_vn = {
    "index": {
        header_1: "Loại ",
        "header_2": "kho lưu trữ nào",
        "header_3": " bạn yêu cầu?",
        "select_option": "Chọn một tùy chọn để tiếp tục",
        "skip_button_text": "Bỏ qua - Hiển thị tất cả giá cả cho tôi",
        "personal": "Cá nhân",
        "business": "Doanh nghiệp",
        "personalText": "Lưu trữ đồ cá nhân, đồ lưu niệm và đồ nội thất nhỏ",
        "businessText": "Lưu trữ an toàn cho hàng tồn kho của doanh nghiệp, tài liệu và thiết bị"
    },
    "journey_bar": {
        "step_1": "Loại Kho Lưu Trữ",
        "step_2": "Kích thước Kho lưu trữ",
        "step_3_a": "Giá cả",
        "step_3_b": "Đặt chỗ",
        "step_4": "Xác nhận",
        "step_5": "Thanh toán",
        "step_6": "Tóm tắt"
    },
    "unit_listing": {
        "header_1": "Bạn yêu cầu ",
        "header_2": "kho kích thước",
        "header_3": " nào?",
        "no_units": "Không có Đơn vị",
        "unit_unavailable_at_move_in": "Đơn vị không còn sẵn có. Vui lòng chọn một đơn vị khác để tiếp tục."
    },
    "book_unit": {
        "header_1": "Chọn một ",
        "header_2": "giao dịch",
        "header_3": "bên dưới",
        "deals": "các giao dịch",
        "inclusions": "Điều gì được bao gồm",
        "click_to_view": "Nhấn để xem"
    },
    "customise_booking": {
        "header_mobile": "Chọn Tùy chọn",
        "upgrade": "Nâng cấp"
    },
    "descriptor": {
        "idealFor": "Lý tưởng cho"
    },
    "carousel": {
        "smaller": "Nhỏ hơn",
        "larger": "Lớn hơn"
    },
    "stack": {
        "inclusions": "Điều gì được bao gồm"
    },
    "labels": {
        "small": "NHỎ",
        "medium": "TRUNG BÌNH",
        "large": "LỚN",
        "or": "Hoặc",
        "easiest_access": "Truy cập dễ dàng nhất"
    },
    "time": {
        "per_week": "Trên Tuần",
        "per_month": "Theo Tháng"
    },
    "sizeSlider": {
        "small": "Nhỏ",
        "medium": "Trung bình",
        "large": "Lớn"
    },
    "cta": {
        "select": "Chọn",
        "continue": "Tiếp tục",
        "step_3": {
            "continue": "Tiếp tục"
        },
        "enquire_now": "Hỏi Ngay",
        "call_us_now": "Gọi Cho Chúng Tôi Ngay Bây Giờ",
        "cancel": "Hủy bỏ",
        "close": "Đóng",
        "bigger_unit": "Cần một kho lớn hơn?",
        "email_us": "Gửi Email cho Chúng Tôi",
        "call_us": "Gọi Cho Chúng Tôi"
    },
    "unit_card": {
        "no_price_chane": "Không Thay Đổi Giá",
        "valued_at": "Được định giá là",
        "customise_booking": "Tùy chỉnh Đặt chỗ",
        "alternative_unit_options": "Các Tùy Chọn Đơn Vị Thay Thế",
        "no_units_available": "Không có đơn vị nào còn trống",
        "extra": "Thêm",
        "save": "Lưu"
    },
    "coupon_code": {
        "title": "Mã Khuyến Mãi / Phiếu Giảm Giá",
        "apply": "Áp dụng",
        "placeholder": "Nhập mã khuyến mãi hoặc mã giảm giá của bạn ở đây",
        "alerts": {
            "success": "Mã khuyến mãi đã được áp dụng thành công",
            "error": "Mã khuyến mãi hết hạn hoặc không hợp lệ"
        }
    },
    "contact_card": {
        "error": "Lỗi",
        "error_text": "Đã xảy ra lỗi khi gửi biểu mẫu. Vui lòng thử lại hoặc liên hệ với trang web của chúng tôi nếu vấn đề này tiếp tục",
        "phone": "Điện thoại",
        "email": "Email",
        "first_name": "Họ",
        "last_name": "Họ",
        "email_address": "Địa chỉ Email",
        "move_in_date": "Ngày dọn vào",
        "phone_number": "Số điện thoại",
        "address": "Địa chỉ",
        "postcode": "Mã bưu chính",
        "city": "Thành phố",
        "state": "Tiểu bang",
        "reservation": {
            "title": "Đặt chỗ",
            "subtitle": "Gần xong rồi! Chúng tôi chỉ cần thêm một số thông tin nữa để hoàn tất việc đặt chỗ của bạn.",
            "success": "Đã đặt trước!",
            "success_detail": "Cảm ơn bạn, đặt chỗ của bạn đã được tạo thành công."
        },
        "quote": {
            "title": "Chi Tiết Báo Giá",
            "subtitle": "Gần xong rồi! Chúng tôi chỉ cần thêm một số thông tin nữa thì báo giá cá nhân của bạn sẽ được gửi qua email.",
            "success": "Đã gửi báo giá!",
            "success_detail": "Cảm ơn bạn, bảng báo giá của bạn đã được gửi đến hộp thư đến của bạn."
        },
        "showPrices": {
            "title": "Hiển thị Giá cả",
            "form_title": "Hiển thị giá cả",
            "submit_text": "Hiển thị Giá",
            "subtitle": "Gần xong rồi! Chúng tôi chỉ cần thêm một vài chi tiết nữa để cung cấp cho bạn một báo giá cá nhân hóa."
        },
        "contactMe": {
            "title": "Hỏi Ngay Bây Giờ",
            "submit_text": "Hỏi Ngay"
        }
    },
    "wizard": {
        "back": "Quay lại",
        "reservation": "Đặt chỗ",
        "scheduleMoveIn": "Lên lịch chuyển vào",
        "copy": "Việc đặt chỗ này yêu cầu phải trả một khoản phí. Vui lòng thực hiện các bước để hoàn thành việc đặt chỗ của bạn. Trong quá trình này, chúng tôi sẽ dành một kho lưu trữ cho bạn và gửi cho bạn một email với các chi tiết.",
        "selectDate": "Chọn ngày bạn muốn chuyển vào.",
        "next": "Tiếp theo",
        "confirm_booking": "Xác nhận đặt chỗ",
        "payViaFinverse": "Thanh toán qua Finverse",
        "process_paypal": "Thanh toán qua PayPal",
        "termsAndConditionsAgree": "Tôi đồng ý với các điều khoản và điều kiện",
        "marketingAgree": "Cho phép tiếp thị",
        "dateOfBirth": "Ngày sinh",
        "otherError": "Một lỗi không mong muốn đã xảy ra, vui lòng làm mới và thử lại hoặc liên hệ hỗ trợ",
        "autobill": "Tự động thanh toán bằng thẻ của tôi để tránh phí trễ",
        "autobillDetails": {
            "title": "Tự động thanh toán",
            "directDebit": "Thanh toán trực tiếp",
            "creditCard": "Thẻ tín dụng",
            "bsbNumber": "Số BSB",
            "accountNumber": "Số Tài Khoản",
            "none": "Không có gì",
            "switchToDebit": ""
        },
        "personal": "Cá nhân",
        "business": "Doanh nghiệp",
        "contactDetails": {
            "title": "Thông tin Liên hệ",
            "titles": {
                "mr": "Ông",
                "mrs": "Bà",
                "miss": "Cô",
                "ms": "Cô",
                "dr": "Dr"
            },
            "commercial": "Vui lòng nhập tên công ty và số đăng ký công ty của bạn. Bạn phải được ủy quyền để hành động thay mặt công ty.",
            "company": "Tên Công Ty",
            "companyNumber": "Số Đăng Ký Doanh Nghiệp"
        },
        "alternateContactDetails": {
            "title": "Thông Tin Liên Hệ Thay Thế",
            "subtitle": "Thông tin này cho phép chúng tôi liên hệ với ai đó nếu chúng tôi không thể liên hệ với bạn."
        },
        "accountDetails": {
            "title": "Chi Tiết Tài Khoản",
            "copy": "Phải từ 8 đến 20 ký tự, bao gồm ít nhất một ký tự viết hoa và viết thường và ít nhất một số. Mật khẩu này sẽ cho phép bạn đăng nhập và thanh toán tài khoản của bạn trực tuyến sau khi chuyển đến.",
            "password": "Mật khẩu trực tuyến",
            "confirmPassword": "Xác nhận Mật khẩu Trực tuyến"
        },
        "reservationWithFee": {
            "orderNumber": "Số Đơn Hàng: ",
            "confirmationText": "Chúng tôi đã gửi cho bạn một email với tất cả chi tiết đơn hàng của bạn & nhớ rằng bạn có thể theo dõi đơn hàng của mình bằng ứng dụng này."
        },
        "reservationConfirmed": {
            "title": "Đã Xác Nhận Đặt Chỗ",
            "subtitle": "Bạn sẽ nhận được một email với thông tin chi tiết về việc đặt chỗ của bạn.",
            "finaliseBooking": "Hoàn tất Đặt chỗ Ngay bây giờ"
        },
        "insuranceCoverage": {
            "title": "Bảo hiểm Bảo vệ",
            "subtitle": "Bảo hiểm không được bao gồm trong phí thuê của chúng tôi. Chúng tôi rất khuyến nghị tất cả khách hàng nên mua bảo hiểm cho hàng hóa của mình để có tâm lý yên tâm.",
            "coverage": "Bảo hiểm",
            "for_up_to": "cho đến ",
            "noInsuranceSelected": "Không có Bảo hiểm được chọn",
            "manualEntryLabel": "Giá trị khai báo của hàng hóa được lưu trữ",
            "disclaimer": "Bằng cách đánh dấu vào ô này, bạn chấp nhận và đồng ý: rằng lựa chọn bảo hiểm đã chọn sẽ bảo đảm giá trị thay thế thực sự của hàng hóa bạn khai báo, đồng ý với các Điều khoản và Điều kiện bên dưới và hiểu rõ những điều bao gồm/không bao gồm trong chính sách.",
            "flatRateInsurance": "Bảo hiểm với mức phí cố định",
            "selfInsurance": "Bảo hiểm Tự nguyện",
            "usSupply": "Chọn tùy chọn này nếu bạn muốn chúng tôi cung cấp bảo hiểm.",
            "subTitle": "Chọn tùy chọn này nếu BẠN sẽ cung cấp bảo hiểm",
            "proofDisclaimer": "Lưu ý: bạn sẽ cần tải lên Bằng chứng Bảo hiểm ở phía dưới để hoàn tất việc đặt chỗ của bạn",
            "fileTypePlease": "Vui lòng tải lên một tệp jpg, png hoặc pdf bằng cách sử dụng phần Chứng minh Bảo hiểm bên dưới.",
            "pickerText": ""
        },
        "addressProof": {
            "title": "Chứng minh địa chỉ",
            "subtitle": "Tải lên tài liệu chứng minh địa chỉ mà bạn đã cung cấp",
            "fileUploadHelpText": "Vui lòng tải lên một bức ảnh chứng minh địa chỉ hiện tại của bạn. Ví dụ như sao kê ngân hàng, sao kê thẻ tín dụng hoặc hóa đơn tiện ích.",
            "uploading": "Đang tải lên...",
            "success": "Tệp đã được tải lên thành công",
            "error": "Lỗi tải lên tệp"
        },
        "insuranceProof": {
            "title": "Bằng chứng Bảo hiểm",
            "subtitle": "Tải lên tài liệu chứng minh việc mua bảo hiểm cho số tiền bạn đã khai báo",
            "fileUploadHelpText": "Ảnh hộ chiếu kiểu (đầu & vai) của bạn.",
            "uploading": "Đang tải lên...",
            "success": "Tệp đã được tải lên thành công",
            "error": "Lỗi khi tải lên tệp"
        },
        "boxShop": {
            "title": "Vật Tư Chuyển Nhà & Đóng Gói",
            "outOfStock": "Hết hàng",
            "pickUpLocation": "Địa điểm nhận hàng",
            "showAll": "Hiển thị tất cả",
            "showLess": "Hiển thị ít hơn"
        },
        "pricingTable": {
            "title": "Tóm tắt Đặt chỗ",
            "charge": "Phí",
            "amount": "Số tiền",
            "discount": "Giảm giá",
            "initialAmount": "Số tiền ban đầu",
            "subtotal": "Tổng phụ",
            "tax": "Thuế",
            "total": "Tổng cộng",
            "including": "bao gồm"
        },
        "identityVerification": {
            "title": "Xác minh danh tính",
            "driverLicenseDetails": "Chi tiết Giấy phép Lái xe",
            "uploadDriverLicense": "Giấy phép lái xe",
            "fileUploadHelpText": "Vui lòng tải lên một ảnh mặt trước của giấy phép lái xe hoặc hình ảnh hộ chiếu của bạn ở định dạng JPG, PNG hoặc PDF",
            "idDocumentNumber": "Số ID Tài liệu"
        },
        "paymentForm": {
            "title": "Thanh toán",
            "errors": {
                "cardHolderInvalid": "Tên chủ thẻ không hợp lệ",
                "cardNumberInvalid": "Số thẻ không hợp lệ",
                "cardExpiryInvalid": "Ngày hết hạn của thẻ không hợp lệ",
                "cardCsvInvalid": "Thẻ CSV không hợp lệ"
            }
        },
        "bookingConfirmation": {
            "title": "Cảm ơn bạn đã đặt chỗ",
            "subtitle": "Chúng tôi đã gửi cho bạn một email với nhiều thông tin chi tiết hơn, vui lòng tham khảo email để biết thêm thông tin.",
            "referenceCode": "Mã tham chiếu của bạn là: ",
            "autobillError": "Việc chuyển đến của bạn đã thành công, nhưng có vấn đề với chi tiết thanh toán tự động của bạn. Vui lòng liên hệ hỗ trợ.",
            "merchPaymentError": "Việc bạn chuyển vào đã thành công, nhưng đã có vấn đề với hàng hóa của bạn. Vui lòng liên hệ hỗ trợ.",
            "insuranceError": "Việc bạn chuyển vào đã thành công, nhưng có vấn đề khi gán bảo hiểm cho bạn. Vui lòng liên hệ hỗ trợ.",
            "customerSurvey": {
                "title": "Khảo sát khách hàng",
                "subtitle": "Chúng tôi thực sự coi trọng phản hồi của khách hàng và sẽ rất vui nếu bạn trả lời một số câu hỏi nhanh dưới đây!",
                "submit": "Gửi Khảo Sát"
            },
            "idVerifyButtonText": "Xác minh ID",
            "idVerifyText": "Vui lòng xác minh ID của bạn bằng cách nhấn nút bên dưới. Nếu không, bạn có thể thực hiện việc này sau trong ứng dụng."
        },
        "marketingSurvey": {
            "title": "Khảo sát Khách hàng",
            "subtitle": "Hãy giúp chúng tôi cải thiện dịch vụ của mình bằng cách trả lời những câu hỏi sau:",
            "Marketing": "Bạn đã nghe về chúng tôi từ đâu?",
            "MktgDistance": "Khoảng cách từ cơ sở?",
            "MktgWhy": "Tại sao bạn đang lưu trữ?",
            "MktgType": "Bạn được mô tả như thế nào?",
            "MktgWhat": "Bạn đang lưu trữ gì?",
            "MktgReason": "Bạn đang lưu trữ với chúng tôi vì lý do gì?",
            "submit": "Gửi Khảo Sát",
            "defaultOption": "Vui lòng chọn một tùy chọn"
        },
        "termsAndConditions": "Điều khoản và Điều kiện"
    },
    "error": {
        "oops": "Rất tiếc! Đã có lỗi xảy ra",
        "subtitle": "Xin lỗi, đã xảy ra lỗi không mong đợi.",
        "general_error": "Một lỗi chung đã xảy ra, vui lòng thử lại hoặc liên hệ hỗ trợ",
        "go_back": "Quay lại",
        "not_found": "Trang bạn yêu cầu không thể tìm thấy, vui lòng kiểm tra có thể bạn đã nhập sai địa chỉ hoặc trang có thể đã được di chuyển.",
        "move_in_error": "Đã có vấn đề với quá trình chuyển vào, vui lòng liên hệ hỗ trợ nếu vấn đề này tiếp tục."
    },
    "map": {
        "map": "Bản đồ",
        "booking": "Đặt chỗ",
        "smaller": "Nhỏ hơn",
        "bigger": "Lớn hơn",
        "select_unit": "Chọn một đơn vị bên dưới",
        "booking_card": {
            "title": "CHI TIẾT ĐẶT CHỖ CỦA BẠN",
            "deals": "ƯU ĐÃI & KHUYẾN MÃI TẠI CƠ SỞ",
            "select_a_deal": "Chọn một giao dịch để áp dụng cho việc đặt chỗ của bạn",
            "different_unit": "Chọn một loại đơn vị khác hoặc tiêu chuẩn bên dưới.",
            "change_size": "Thay đổi Kích cỡ"
        }
    },
    "errors": {
        "10000": "Đã xảy ra lỗi, vui lòng thử lại sau.",
        "10001": "Đơn vị đã được thuê hoặc không còn khả dụng.",
        "50716": "Giao dịch bị từ chối. Xác thực 3D Secure thất bại"
    }
};
